export const dataOverviewListMapper = (response) => {
  if (!response || !response.success || !Array.isArray(response.data)) {
    return [];
  }

  return response.data.map((item) => ({
    tag: item.tag,
    text: item.text,
    raw_signal_mapping: item.raw_signal_mapping,
    unit: item.unit || "",
    decimals: Number.isInteger(Number(item.decimals))
      ? Number(item.decimals)
      : 2,
    is_disabled: Number(item.is_disabled) === 1,
    is_default:  Number(item.is_default )=== 1,
  }));
};
